import { denormalize, normalize, schema } from "normalizr";

export const normalizeEntity = (datasources) => {
	const isArray = datasources instanceof Array;
	const dataset = isArray ? "taxes" : "tax";
	const taxEntity = new schema.Entity(dataset);
	const result = normalize(
		datasources, 
		isArray ? [taxEntity] : taxEntity
	);
	
	return result.entities;
}

export const denormalizeEntity = (datasources) => {
	const isArray = datasources.taxes;
	const dataset = isArray ? "taxes" : "tax";
	const taxEntity = new schema.Entity(dataset)
	const entities = isArray ? datasources.taxes : datasources.tax;

	return denormalize(
		{ [dataset]: isArray ? Object.keys(entities) : Object.keys(entities).toString() }, 
		{ [dataset]: isArray ? [taxEntity] : taxEntity }, 
		{ [dataset]: entities }
	);
}